import CityLandingPage from './CityLandingPage';
import { cityPages } from '@/mocks/cityPages';

const data = cityPages.find((c) => c.slug === 'electronics-recycling-inglewood')!;

const InglewoodPage = () => <CityLandingPage data={data} />;

export default InglewoodPage;
